import React from 'react';
import { connect } from 'react-redux';
import Skeleton from 'ui/Skeleton';
import useFeatureFlags from 'hooks/useFeatureFlags';
import DateFormat from 'constants/date_format';

const AssignmentDate = props => {
  const hasChangeAssignmentsToResources = useFeatureFlags(
    'change_assignments_to_resources',
  );

  let date;
  if (props.completedDate) {
    date = t('paths.dashboard.status.completed_on', {
      date: props.completedDate,
    });
  } else if (props.dueDate) {
    date = t('paths.dashboard.status.due_on', { date: props.dueDate });
  } else if (props.assignDate) {
    date = hasChangeAssignmentsToResources
      ? t('paths.dashboard.status.shared_on', {
          date: moment(props.assignDate).format(DateFormat.LONG),
        })
      : t('paths.dashboard.status.assigned_on', {
          date: moment(props.assignDate).format(DateFormat.LONG),
        });
  } else if (!props.loading && !props.previewing) {
    return false;
  }

  return (
    <div className="PathViewerHeader-dateContainer d-f ai-c">
      <div className="PathViewerHeader-date">
        {props.loading ? <Skeleton width={264} /> : date}
      </div>
      {props.isOverdue && (
        <div className="Pill Pill--danger">
          {t('paths.dashboard.status.overdue')}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({ pathViewer }) => ({
  loading: pathViewer.loading,
  previewing: pathViewer.previewing,
});

export default connect(mapStateToProps)(AssignmentDate);
